<template>
  <div class='disability-rate'>
    <p>{{ 'report-of-sickness.disability-rate' | translate }}</p>
    <div class='fl hf'>
      <p class='current-rate hf'>{{ current }}%</p>
      <p v-if="current != null && previous != null" :class="positive ? 'difference-indicator positive' : 'difference-indicator negative'">
      {{ positive ? '-' : '+' }}{{ difference.toString().replace('-', '') }}%</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisabilityRateDifference',
  props: {
    current: null,
    previous: null
  },

  computed: {
    difference () {
      return parseFloat(this.previous) - parseFloat(this.current);
    },
    positive () {
      return this.difference > 0;
    }
  }
};
</script>

<style lang='scss' scoped>
  @import '@/assets/stylesheets/variables.scss';

  .disability-rate {
    text-align: left;

    .current-rate {
      font-size: 2.2em;
      font-weight: 500;
      color: $primary-lighten-1;
      margin-top: -1px;
      margin-bottom: -5px;
    }

    .difference-indicator {
      padding: 4px 8px;
      border-radius: $border-radius;
      font-size: 1em;
      font-weight: 600;
      max-width: 70px;
      height: 34px;
      float: right;
      top: 10px;
      position: relative;

      &.positive {
        color: $positive;
        background-color: $positive-lighten-3;
      }

      &.negative {
        color: $error;
        background-color: $error-lighten-4;
      }
    }
  }
</style>
